<template>
  <div class="info-container">
    <div class="public flex-column">
      <div class="header flex-row">
        <a :href="$attrs.fixedAppUrl.noticeCenter" target="_blank">校园动态</a>
        <el-select size="small" v-model="search.categoryCode" @change="getNoticeList" :popper-append-to-body="false"
          clearable>
          <el-option v-for="item in noticeType" :key="item.id" :value="item.code" :label="item.name"></el-option>
        </el-select>
      </div>
      <ul class="scroll">
        <li class="item flex-row" v-for="item in noticeList" :key="item.id" @click="openDialog('notice', item)">
          <div class="date flex-column">
            <div class="day" v-text="item.publishTime.substring(8, 10)"></div>
            <div class="year-month" v-text="item.publishTime.substring(0, 7)"></div>
          </div>
          <el-divider direction="vertical"></el-divider>
          <div class="content flex-column">
            <div class="top flex-row">
              <div class="title" v-text="item.name"></div>
              <div class="time" v-text="item.publishTime.substring(11, 19)"></div>
            </div>
            <div class="detail" v-text="item.content"></div>
          </div>
        </li>
      </ul>
    </div>
    <div class="calendar flex-column">
      <div class="header flex-row">
        <a :href="$attrs.fixedAppUrl.weekCalendar" target="_blank">待办事项</a>
        <el-select size="small" v-model="selectType" @change="getWeekWorkList(selectDay)"
          :popper-append-to-body="false">
          <el-option label="学校事项" :value="1"></el-option>
          <el-option label="个人事项" :value="2"></el-option>
        </el-select>
      </div>
      <div class="center flex-row">
        <div class="left flex-column">
          <ul class="scroll">
            <li class="item" v-for="item in dayWorkList" :key="item.id" @click="openDialog('todo', item)">
              <div class="time">
                <i class="el-icon-time"></i>
                <b>{{ item.startTime }} ~ {{ item.endTime }}</b>
              </div>
              <div class="detail">
                <span>{{ item.content }}</span>
                <span v-if="item.address">— {{ item.address }}</span>
              </div>
            </li>
          </ul>
          <div class="footer flex-row">
            <div class="prev flex-row" @click="changeWeek('prev')">
              <i class="el-icon-caret-left"></i>
              <span>上一周</span>
            </div>
            <span>/</span>
            <span>{{ monday.substring(0, 7) }}</span>
            <span>/</span>
            <div class="next flex-row" @click="changeWeek('next')">
              <span>下一周</span>
              <i class="el-icon-caret-right"></i>
            </div>
          </div>
        </div>
        <div class="right flex-column">
          <div class="week flex-column" v-for="item in weekList" @click="getWeekWorkList(item.date)"
            :class="item.active ? 'active' : ''">
            <span>{{ item.week }}</span>
            <p>{{ item.date.substring(8, 10) }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNoticeListApi, getNoticeTypeApi, getWeekWorkListApi } from './api'
import moment from 'moment'
export default {
  name: "Info",
  props: ['openDialog', 'handleScroll'],
  data() {
    return {
      noticeType: [],
      search: {
        publishStatus: 1,
        categoryCode: '',
        pageParam: {
          current: 1,
          size: 10
        }
      },
      noticeList: [],
      dayWorkList: [],
      monday: moment().weekday(1).format('YYYY-MM-DD'),
      today: moment().format('YYYY-MM-DD'),
      selectDay: '',
      selectType: 1,
      weekList: [{
        week: '周一',
        date: '',
        num: '3',
        active: false
      }, {
        week: '周二',
        date: '',
        num: '2',
        active: false
      }, {
        week: '周三',
        date: '',
        num: '3',
        active: false
      }, {
        week: '周四',
        date: '',
        num: '1',
        active: false
      }, {
        week: '周五',
        date: '',
        num: '',
        active: false
      }, {
        week: '周六',
        date: '',
        num: '',
        active: false
      }, {
        week: '周日',
        date: '',
        num: '13',
        active: false
      }]
    }
  },
  async created() {
    const { data: { categoryList } } = await getNoticeTypeApi()
    this.noticeType = categoryList
    this.getNoticeList()
    this.getWeekList()
    this.getWeekWorkList(this.today)
  },
  methods: {
    async getNoticeList() {
      const { data } = await getNoticeListApi(this.search)
      this.noticeList = data.articleList
    },
    getWeekWorkList(date) {
      this.selectDay = date
      this.weekList.forEach(async item => {
        item.active = false
        if (item.date === date) {
          item.active = true
          const params = {
            workType: this.selectType,
            startDate: date,
            endDate: date
          }
          const { data: { weekWorkList } } = await getWeekWorkListApi(params)
          this.dayWorkList = weekWorkList[0].weekWorks
        }
      })
    },
    getWeekList() {
      for (let i = 0; i < 7; i++) {
        this.weekList[i].date = moment(this.monday).add(i, "days").format("YYYY-MM-DD")
      }
    },
    changeWeek(action) {
      if (action === 'prev') {
        this.monday = moment(this.monday).subtract(7, "days").format("YYYY-MM-DD")
      }
      if (action === 'next') {
        this.monday = moment(this.monday).add(7, "days").format("YYYY-MM-DD")
      }
      this.getWeekList()
      this.weekList.forEach(item => item.active = false)
      this.getWeekWorkList(this.selectDay)
    }
  }
}
</script>

<style lang="scss" scoped>
.info-container {
  height: 100%;
  background: no-repeat center/cover url('../../assets/info.png');
  color: #fff;
  padding: 15vh 5vh 5vh 10vh;
  display: flex;
  justify-content: space-between;

  .public {
    width: 40%;
    height: 100%;
    gap: calc(30*var(--ratio));

    .header {
      width: 100%;

      a {
        font-size: calc(40*var(--ratio));
        cursor: pointer;
        font-weight: bold;
      }
    }


    .scroll {
      width: 100%;
      flex-grow: 1;
      height: 0;
      overflow: auto;

      &::-webkit-scrollbar {
        display: none;
      }

      .item {
        height: calc(100*var(--ratio));
        padding: calc(20*var(--ratio)) 0;
        transition: 300ms ease-in-out;
        cursor: pointer;

        &:hover {
          background: #ffffff33;
          padding: calc(20*var(--ratio));
        }

        .date {
          .day {
            font-size: calc(45*var(--ratio));
            line-height: 1;
            font-weight: bold;
          }

          .year-month {
            font-size: calc(12*var(--ratio));
            white-space: nowrap;
          }
        }

        .el-divider {
          height: 100%;
          margin: 0 calc(20*var(--ratio));
          background: #ffffff33;
        }

        .content {
          flex-grow: 1;
          width: 0;
          height: 100%;

          .top {
            align-items: flex-start;
            width: 100%;

            .title {
              font-size: calc(20*var(--ratio));
              font-weight: bold;
              flex-grow: 1;
              width: 0;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }

            .time {
              margin-left: calc(10*var(--ratio));
              font-size: calc(12*var(--ratio));
            }
          }

          .detail {
            font-size: calc(16*var(--ratio));
            width: 100%;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            color: #ffffff50;
          }
        }
      }
    }

  }

  .calendar {
    width: 35%;
    height: 100%;
    gap: calc(30*var(--ratio));

    .header {
      width: 100%;

      a {
        font-size: calc(40*var(--ratio));
        cursor: pointer;
        font-weight: bold;
      }

      .select {
        gap: calc(20*var(--ratio));
      }

      span {
        font-size: calc(22*var(--ratio));
        color: #ffffff70;
      }
    }

    .center {
      width: 100%;
      flex-grow: 1;
      height: 0;
      gap: calc(30*var(--ratio));

      .left {
        height: 100%;
        flex-grow: 1;
        width: 0;
        gap: calc(30*var(--ratio));


        .scroll {
          width: 100%;
          flex-grow: 1;
          height: 0;
          overflow: auto;

          &::-webkit-scrollbar {
            display: none;
          }

          .item {
            height: calc(100*var(--ratio));
            padding: calc(20*var(--ratio)) 0;
            transition: 300ms ease-in-out;
            cursor: pointer;

            &:hover {
              background: #ffffff33;
              padding: calc(20*var(--ratio));
            }

            .time {
              font-size: calc(20*var(--ratio));

              b {
                margin-left: calc(10*var(--ratio));
              }
            }

            .detail {
              width: 100%;
              margin-top: calc(15*var(--ratio));
              color: #ffffff90;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;

              span {
                margin-right: calc(10*var(--ratio));
              }
            }
          }
        }

        .footer {
          width: 100%;
          justify-content: flex-start;
          gap: calc(50*var(--ratio));
          color: #ffffff70;
          font-size: calc(18*var(--ratio));
          font-weight: bold;

          .prev,
          .next {
            cursor: pointer;
            transition: 300ms;
            user-select: none;
            gap: calc(4*var(--ratio));

            &:hover {
              color: #fff;
            }
          }
        }
      }

      .right {
        height: 100%;

        .week {
          cursor: pointer;
          color: #ffffff70;
          transition: 300ms;
          gap: calc(5*var(--ratio));
          user-select: none;

          &.active {
            color: lighten($homeRed, 10%);
          }

          &:hover:not(.active) {
            color: #fff;
          }

          span {
            font-size: calc(20*var(--ratio));
          }

          p {
            font-size: calc(45*var(--ratio));
            font-weight: bold;
          }
        }
      }
    }
  }

  ::v-deep.el-input__inner {
    background: transparent;
    backdrop-filter: blur(10px);
    border-radius: 0;
    color: #fff;
  }

  ::v-deep.el-select-dropdown.el-popper {
    background: transparent;
    backdrop-filter: blur(10px);
    border-radius: 0;

    .popper__arrow::after {
      display: none;
    }

    .el-select-dropdown__item {
      color: #fff;

      &.hover {
        color: $mainColor;
        background: transparent;
      }
    }
  }
}
</style>